/**
 * Adds a diagonal watermark "RP NOTICIAS • EVIDENCIA" to an image blob.
 * Returns a new PNG blob. Falls back to the original blob on error.
 */
export async function watermarkImageBlob(blob, refCode = '') {
  try {
    const bitmap = await createImageBitmap(blob);
    const canvas = document.createElement('canvas');
    canvas.width = bitmap.width;
    canvas.height = bitmap.height;
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('no canvas context');

    // Draw original image
    ctx.drawImage(bitmap, 0, 0);

    const w = canvas.width;
    const h = canvas.height;
    const shorter = Math.min(w, h);

    // Diagonal repeating watermark
    ctx.save();
    ctx.translate(w / 2, h / 2);
    ctx.rotate(-Math.PI / 6);
    const fontSize = Math.max(14, Math.round(shorter * 0.05));
    ctx.font = `900 ${fontSize}px "Archivo Black", Impact, sans-serif`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    const text = 'RP NOTICIAS • EVIDENCIA';
    const stepY = fontSize * 2.5;
    const stepX = ctx.measureText(text).width + fontSize * 2;
    const diag = Math.ceil(Math.sqrt(w * w + h * h)) + stepX;
    for (let y = -diag; y <= diag; y += stepY) {
      for (let x = -diag; x <= diag; x += stepX) {
        ctx.fillStyle = 'rgba(11, 31, 64, 0.14)';
        ctx.fillText(text, x, y);
      }
    }
    ctx.restore();

    // Bottom-right badge with brand + ref
    const badgePad = Math.max(10, Math.round(shorter * 0.015));
    const badgeFont = Math.max(12, Math.round(shorter * 0.025));
    ctx.font = `900 ${badgeFont}px "Archivo Black", Impact, sans-serif`;
    const badgeText = refCode ? `RP NOTICIAS · ${refCode}` : 'RP NOTICIAS';
    const metrics = ctx.measureText(badgeText);
    const bw = metrics.width + badgePad * 2;
    const bh = badgeFont + badgePad;
    const bx = w - bw - badgePad;
    const by = h - bh - badgePad;
    ctx.fillStyle = '#E50B15';
    ctx.fillRect(bx, by, bw, bh);
    ctx.fillStyle = '#FFFFFF';
    ctx.textAlign = 'left';
    ctx.textBaseline = 'middle';
    ctx.fillText(badgeText, bx + badgePad, by + bh / 2);

    return await new Promise((resolve) => canvas.toBlob((b) => resolve(b || blob), 'image/png', 0.92));
  } catch (e) {
    console.warn('Watermark failed, using original:', e);
    return blob;
  }
}

/** True if the blob is a supported raster image we can watermark. */
export function isWatermarkableImage(blob) {
  const t = (blob?.type || '').toLowerCase();
  return t.startsWith('image/') && !t.includes('svg');
}
